import {Component, ViewChild, ElementRef, Renderer, OnInit, OnDestroy} from "@angular/core";
import {AuthentService} from "../../services/authent.service";
import {BusinessService} from "../../services/data/business.service";
import {FileUploader, FileUploaderOptions} from "ng2-file-upload/index";
import {UrlService} from "../../services/url.service";
import {CurrentBusinessService} from "../../services/communication/currentBusinessService";
import {Business} from "../../model/business";
import {NotificationsService} from "angular2-notifications/components";
import {ActivatedRoute} from "@angular/router";
import {BusinessBill} from "../../model/bill/business-bill";
import {ConfigurationService} from "../../services/configuration.service";
import {Subscription} from "rxjs";

declare const $: any;

@Component({
  selector: 'profile-page',
  template: require('./profile-page.component.html'),
  styles: [
    require('./profile-page.component.scss')
  ]
})

export class ProfilePageComponent implements OnInit, OnDestroy {

  @ViewChild('bannerInput') fileInput: ElementRef;

  @ViewChild('logoInput') logoInput: ElementRef;

  public bannerUploader: MyProfileUploader;

  public logoUploader: MyProfileUploader;

  uploaderOptions: FileUploaderOptions = {};

  activeTab: string = 'profile';

  logoPath: string;
  bannerPath: string;
  business: Business;
  model: Business;

  bills: BusinessBill[];

  pageReady: boolean = false;

  coverHeight: number;
  topMinimum: boolean = false;
  topMinified: boolean = false;

  apiBase: string;
  token: string;

  publicLink: string;

  private businessSubscription: Subscription = null;
  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    if (this.businessSubscription != null) {
      this.businessSubscription.unsubscribe();
    }
    this.paramSubscription.unsubscribe();
  }

  ngOnInit() {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        let tab = param['tab'];

        if (tab != null) {
          this.activeTab = tab;
        }
      });
  }

  constructor(private authent: AuthentService, private businessService: BusinessService,
              private urlService: UrlService, private renderer: Renderer,
              private currentBusinessService: CurrentBusinessService, private notificationService: NotificationsService,
              private activatedRoute: ActivatedRoute, private configService: ConfigurationService) {
    this.uploaderOptions.autoUpload = true;
    this.apiBase = configService.baseUrl;
    this.token = authent.getToken();

    if (currentBusinessService.currentBusiness != null && currentBusinessService.currentBusiness.logoPath != null) {
      this.business = JSON.parse(JSON.stringify(currentBusinessService.currentBusiness));
      this.model = currentBusinessService.currentBusiness;
      this.publicLink = this.configService.getFamiliesPublicUrl() + '/organization/' + this.business.id + '/' + this.business.name;
      this.initPage();
    }

    this.businessSubscription = currentBusinessService.businessChange$.subscribe(
      business => {
        this.business = JSON.parse(JSON.stringify(currentBusinessService.currentBusiness));
        this.model = currentBusinessService.currentBusiness;
        this.publicLink = this.configService.getFamiliesPublicUrl() + '/organization/' + this.business.id + '/' + this.business.name;
        this.initPage();
      }
    );
  }

  initPage() {
    let token = 'Bearer ' + this.authent.getToken();

    this.logoPath = this.urlService.getUploadBusinessLogoUrl(this.business.id) + '?access_token=' + this.authent.getToken();
    this.bannerPath = this.urlService.getUploadBusinessBannerUrl(this.business.id) + '?access_token=' + this.authent.getToken();

    let headers = {
      name: 'Authorization',
      value: token
    };

    this.uploaderOptions.headers = [headers];

    this.bannerUploader = new MyProfileUploader({
      url: this.urlService.getUploadBusinessBannerUrl(this.business.id),
      authToken: token
    });
    this.bannerUploader.setOptions(this.uploaderOptions);
    this.bannerUploader.onCompleteAll = () => {
      this.bannerPath += '&t=12';
    };

    this.logoUploader = new MyProfileUploader({
      url: this.urlService.getUploadBusinessLogoUrl(this.business.id),
      authToken: token
    });
    this.logoUploader.setOptions(this.uploaderOptions);
    this.logoUploader.onCompleteAll = () => {
      this.logoPath += '&t=12';
      this.currentBusinessService.reloadLogo();
    };

    this.pageReady = true;
    this.bindPageScroll();
    this.loadBills();
  }

  showBannerBrowseDlg() {
    let event = new MouseEvent('click', {bubbles: true});

    this.renderer.invokeElementMethod(
      this.fileInput.nativeElement, 'dispatchEvent', [event]);
  }

  showLogoBrowseDlg() {
    let event = new MouseEvent('click', {bubbles: true});

    this.renderer.invokeElementMethod(
      this.logoInput.nativeElement, 'dispatchEvent', [event]);
  }

  activateTab(tab: string) {
    this.activeTab = tab;
  }

  publicProfileChange(checked: boolean) {
    this.business.publicProfile = checked;
    this.profileChange();
  }

  profileChange() {

    if (this.hasDifference(this.model, this.business)) {
      this.businessService.updateBusiness(this.business).subscribe(
        business => {
          this.currentBusinessService.changeBusiness(business);
          this.notificationService.success('Profil', 'Les modifications ont été appliquées');
        },
        error => {
          this.business = JSON.parse(JSON.stringify(this.model));
          this.notificationService.error('Profil', 'Les données saisies sont invalides');
        }
      )
    }
  }

  bindPageScroll() {
    let that = this;

    $(document).ready(function () {

      that.coverHeight = $(window).height() / 2;

      $(window).scroll(function (event) {
        that.handleTopSize();
      });

      $(window).resize(function () {
        that.coverHeight = $(window).height() / 2;
        that.handleTopSize();
      })
    });
  }

  handleTopSize() {
    if ($(window).width() > 760) {
      let scroll = $(window).scrollTop();
      let $topProfile = $('.top-profile');

      if (this.coverHeight == null) {
        this.coverHeight = $topProfile.height();
      }

      let size = this.coverHeight - scroll;

      if (size > 130) {
        $topProfile.height(this.coverHeight - scroll);
        this.topMinimum = false;
      } else {
        this.topMinimum = true;
      }

      if (size < (this.coverHeight / 3 * 2)) {
        this.topMinified = true;
      } else {
        this.topMinified = false;
      }
    } else {
      this.topMinified = true;
    }
  }

  loadBills() {
    this.businessService.getBills(this.business.id).subscribe(
      bills => this.bills = bills
    )
  }

  activationEmail() {
    if (this.business.email != '') {
      this.businessService.sendActivationEmail(this.business.id).subscribe(
        response => this.notificationService.success('Email', 'Un email de confirmation vous a été envoyé')
      )
    } else {
      this.notificationService.error('Email', 'Veuillez d \'abord saisir un email');
    }
  }

  associationChange(checked: boolean) {
    this.business.association = checked;
    this.profileChange();
  }

  private hasDifference(business1: Business, business2: Business): boolean {
    if (business1.name != business2.name) {
      return true;
    }
    if (business1.description != business2.description) {
      return true;
    }
    if (business1.street != business2.street) {
      return true;
    }
    if (business1.zipCode != business2.zipCode) {
      return true;
    }
    if (business1.city != business2.city) {
      return true;
    }
    if (business1.country != business2.country) {
      return true;
    }
    if (business1.taxNumber != business2.taxNumber) {
      return true;
    }
    if (business1.websiteUrl != business2.websiteUrl) {
      return true;
    }
    if (business1.email != business2.email) {
      return true;
    }
    if (business1.publicProfile != business2.publicProfile) {
      return true;
    }
    if (business1.association != business2.association) {
      return true;
    }

    return false;
  }
}

export class MyProfileUploader extends FileUploader {
  onAfterAddingFile(request: any) {
    request.withCredentials = false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/profile/profile-page.component.ts